import { ApplicationElement, html } from '@effectivastudio/lit-components';
import style from './style.lit.css';
import '../fa_icon/element.js';
import '@effectivastudio/lit-components/components/badge/element.js';

/**
 * Icon with badge example
 *
 * @prop name - Name of the icon class
 * @prop badgeCount - Number of the badge counter
 */
export default class Icon extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  static properties = {
    name: { type: String, reflect: true },
    badgeCount: { type: Number, reflect: true },
  };

  renderBadge() {
    return html`<ef-badge count="${this.badgeCount}"></ef-badge>`;
  }

  renderIcon() {
    return html`<fa-icon .name=${this.name}></fa-icon>`;
  }

  render() {
    return html`
      ${this.renderIcon()} ${this.badgeCount > 0 ? this.renderBadge() : null}
    `;
  }
}

customElements.get('bu-icon') || customElements.define('bu-icon', Icon);
